/**
 * PDF Templates Page
 * Wrapper page for PDF Template Management component
 */

import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import PDFTemplateManagement from '../../components/admin/PDFTemplateManagement';

function PDFTemplatesPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        PDF Templates
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Manage document templates for contracts and reports
      </Typography>
      <Paper sx={{ p: 2 }}>
        <PDFTemplateManagement />
      </Paper>
    </Box>
  );
}

export default PDFTemplatesPage;
